










































































































import { Component, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import BaseTable from '@/components/BaseTable.vue';
import BasePagination from '@/components/base/BasePagination.vue';
import BaseLoading from '@/components/base/BaseLoading.vue';
import { PaginationMixin } from '@/components/base/pagination.mixin';
import TableActionDropdown from '@/components/TableActionDropdown.vue';
import SortableTableHeader from '@/components/SortableTableHeader.vue';
import { isUserAllowed } from '@/utils/rbac.util';
import { PermissionsMatrixActionsEnum } from '@/store/modules/roles-and-permissions/types/roles-and-permissions.types';
import { FHIRClient } from '../types/admin-fhir-access-management.types';

@Component({
  computed: {
    PermissionsMatrixActionsEnum() {
      return PermissionsMatrixActionsEnum;
    }
  },
  methods: { isUserAllowed },
  components: {
    BaseTable,
    BasePagination,
    BaseLoading,
    TableActionDropdown,
    SortableTableHeader
  },
  filters: {
    formatDate(value: string) {
      if (!value) return '';
      return new Date(value).toLocaleDateString('en-GB', {
        day: 'numeric',
        month: 'short',
        year: 'numeric'
      });
    }
  }
})
export default class FHIRClientsList extends mixins(PaginationMixin) {
  sortHeaders = [
    { placeholder: 'Client Name', sortColumn: 'client.name', sort: true },
    { placeholder: 'Email', sortColumn: 'client.email', sort: false },
    { placeholder: 'Last Updated', sortColumn: 'client.updatedAt', sort: true },
    { placeholder: 'Status', sort: false }
  ];

  @Prop() public items!: FHIRClient[];
  @Prop(Number) public totalNumberOfPage!: number;
  @Prop(Number) public totalCount!: number;
  @Prop(Boolean) public isFirstPage!: boolean;
  @Prop(Boolean) public isLastPage!: boolean;
  @Prop(Number) public startItemIndex!: number;
  @Prop(Number) public endItemIndex!: number;
  @Prop(String) public sortColumn!: string;
  @Prop(String) public sortOrder!: 'ASC' | 'DESC';

  public onClickHeaderColumn(columnName: string) {
    if (this.sortColumn === columnName) {
      return this.$emit('sort', {
        sortColumn: columnName,
        sortOrder: this.sortOrder === 'ASC' ? 'DESC' : 'ASC'
      });
    }
    this.$emit('sort', { sortColumn: columnName, sortOrder: 'DESC' });
  }

  public getSortOrderOfColumn(name: string) {
    return this.sortColumn === name ? this.sortOrder : 'ASC';
  }

  public viewClient(item: FHIRClient) {
    this.$emit('viewClient', item);
  }

  public editClient(item: FHIRClient) {
    this.$emit('editClient', item);
  }

  public deleteClient(item: FHIRClient) {
    this.$emit('deleteClient', item);
  }

  public toggleStatus(item: FHIRClient) {
    this.$emit('toggleStatus', item);
  }
}
